export default function fillAddress(autocomplete, submit, autocompleteRef) {
  return async function () {
    //if (!autocomplete) return //1. changed here
    if (!autocomplete || !autocompleteRef.current || !autocompleteRef.current.input) return;

    // 2. changed here 
    const selectedDescription = autocompleteRef.current.input.value.trim();
    //console.log('selectedDescription', selectedDescription);
    if (!selectedDescription) return;

    let place = await autocomplete.getPlace()
    const geocoder = new window.google.maps.Geocoder()

    // if (place && place.formatted_address) {
    //   geocoder.geocode({address: place.formatted_address}, (results) => {
    //     submit(JSON.parse(JSON.stringify(results)))
    //   })
    // } else submit(null)

    geocoder.geocode({ address: selectedDescription }, (results) => {
      // Grok suggestion: Optional fallback—if geocoding fails (rare), use place details as a single-item array to match expected format
      if (!results || !results.length) {
        if (place && place.geometry) {
          submit([{ ...place }]); // Wrap as array to match expected format
        } else {
          submit(null);
        }
        return;
      }
      submit(JSON.parse(JSON.stringify(results)));
    });

  }
}
